module.exports = __webpack_public_path__ + "images/pre-footer-icons.webp";